import { FC } from 'react';

import { ShopItemForStoreData } from '@shared/api/shopItem/shopItem.interface';
import { Loading } from '@shared/components/Loading';
import { fileBucketUrl } from '@shared/utils/fileUtils';
import { formatPrice } from '@shared/utils/formatPrice';
import { createPortal } from 'react-dom';

interface PaymentWidgetModalProps {
  isOpen: boolean;
  isReady: boolean;
  isSubmitting: boolean;
  shopItem: ShopItemForStoreData | null;
  itemCount: number;
  totalAmount: number;
  onPay: () => void;
  onClose: () => void;
}

const PaymentWidgetModal: FC<PaymentWidgetModalProps> = ({
  isOpen,
  isReady,
  isSubmitting,
  shopItem,
  itemCount,
  totalAmount,
  onPay,
  onClose,
}) => {
  return createPortal(
    <div className="Preed">
      <div
        className="fixed inset-0 z-40 flex flex-col bg-white transition-transform duration-300"
        style={{
          transform: isOpen ? 'translateY(0)' : 'translateY(100%)',
          pointerEvents: isOpen ? 'auto' : 'none',
        }}
      >
        {/* 모달 헤더 */}
        <div className="flex items-center justify-between border-b px-4 py-3">
          <h2 className="text-lg font-bold">결제 수단 선택</h2>
          <button
            type="button"
            onClick={onClose}
            className="flex h-8 w-8 items-center justify-center rounded-full text-gray-500 hover:bg-gray-100"
          >
            <svg
              className="h-5 w-5"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>
        {/* 주문 요약 */}
        {shopItem && (
          <div className="flex items-center gap-3 border-b px-4 py-3">
            <img
              src={fileBucketUrl(shopItem.shopItemInfo.image.url, 'w400')}
              alt={shopItem.shopItemInfo.name}
              className="h-12 w-12 rounded object-cover"
            />
            <div className="flex-1">
              <p className="text-sm font-medium">{shopItem.shopItemInfo.name}</p>
              <p className="text-xs text-gray-500">{itemCount}개</p>
            </div>
            <p className="text-base font-bold">{formatPrice(totalAmount)}원</p>
          </div>
        )}
        {/* 토스페이먼츠 위젯 컨테이너 */}
        <div className="flex-1 overflow-y-auto px-4 py-4">
          {!isReady && (
            <div className="flex items-center justify-center py-8">
              <Loading />
            </div>
          )}
          <div id="toss-payment-method" style={{ opacity: isReady ? 1 : 0 }} />
        </div>
        {/* 결제 버튼 */}
        <div className="border-t px-4 py-3">
          <button
            type="button"
            onClick={onPay}
            disabled={!isReady || isSubmitting}
            className="w-full rounded-lg py-4 text-base font-bold text-white theme-bg-main disabled:opacity-50"
          >
            {isSubmitting ? '결제 요청 중...' : `${formatPrice(totalAmount)}원 결제하기`}
          </button>
        </div>
      </div>
    </div>,
    document.body,
  );
};

export default PaymentWidgetModal;
